<header class="app-header" fxLayout="row" fxLayoutAlign="space-between">
  <digital-platform-logo
    class="logo"
    fxFlex="15"
    fxLayoutAlign="center center"
  ></digital-platform-logo>

  <div class="app-name" fxFlex="83.75">
    <h1 id="title">Special Waste Hub</h1>
  </div>

  <button
    *ngIf="!isContactUs"
    title="Contact Us"
    mat-button
    fxFlex="3.25"
    fxLayoutAlign="center center"
    class="contact-button"
    (click)="handleContactModal()"
  >
    <mat-icon inline="true" svgIcon="contact-mail"></mat-icon>
  </button>
  <ng-template #contactCustomerDialog>
    <div>
      <h2 mat-dialog-title>Contact Us</h2>
      <button
        mat-icon-button
        cdkFocusInitial
        class="close"
        aria-label="Close dialog"
        color="accent"
        (click)="closeAll()"
        [disableRipple]="true"
      >
        <mat-icon>close</mat-icon>
      </button>
      <div mat-dialog-content>
        <div>
          Please contact your sales coordinator or sales representative for
          assistance.
        </div>
      </div>
    </div>
  </ng-template>
  <div *ngIf="!universalLogin">
    <div
      *ngIf="!isContactUs"
      class="divider"
      style="border-left: 3px solid #000"
    ></div>
    <button
      title="Logout"
      (click)="onClickLogout()"
      mat-button
      fxFlex="3"
      fxLayoutAlign="center center"
      class="logout-button"
    >
      <mat-icon inline="true">logout</mat-icon>
    </button>
  </div>
</header>
